/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Date } from '../../models/date';

export interface MainControllerGetServerTimeSinceUp$Params {
}

export function mainControllerGetServerTimeSinceUp(http: HttpClient, rootUrl: string, params?: MainControllerGetServerTimeSinceUp$Params, context?: HttpContext): Observable<StrictHttpResponse<Date>> {
  const rb = new RequestBuilder(rootUrl, mainControllerGetServerTimeSinceUp.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Date>;
    })
  );
}

mainControllerGetServerTimeSinceUp.PATH = '/time';
